import React, { useContext, useState } from 'react';
import { useStyletron } from 'baseui';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { AppContext, CSV_LINK_LABEL, CustomDateColumn, EMPTY_STRING, NONE_LABEL, STATUS_COLORS, WHITE } from 'commons-ui';
import { buttonStyles, linkStyles } from 'pages/dashboard/utilities/assetUpload/submodules/list/listConfigStyle';

export const COL_NAMES = {
	csvLink: 'csvLink',
	toBeDeleted: 'toBeDeleted',
	purpose: 'purpose',
	createdBy: 'email',
	createdAt: 'createdAt',
	processingStatus: 'processingStatus',
	rowCount: 'rowCount',
	uniqueSegments: 'uniqueSegments'
};

export const columnConfigs = [
	StringColumn({
		title: 'Purpose',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.purpose] || EMPTY_STRING,
		columnName: COL_NAMES.purpose
	}),
	CustomColumn({
		title: 'Processing Status',
		minWidth: 100,
		maxWidth: 120,
		mapDataToValue: (data: any) => data[COL_NAMES.processingStatus],
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: `${STATUS_COLORS.get(text)}`,
						color: WHITE,
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Row Count',
		minWidth: 80,
		maxWidth: 100,
		mapDataToValue: (data: any) => String(data[COL_NAMES.rowCount]) || EMPTY_STRING,
		columnName: COL_NAMES.rowCount
	}),
	StringColumn({
		title: 'Unique Segments',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.uniqueSegments] || EMPTY_STRING,
		columnName: COL_NAMES.uniqueSegments
	}),
	CustomColumn({
		title: 'CSV Link',
		minWidth: 120,
		maxWidth: 120,
		mapDataToValue: (data: any) => data[COL_NAMES.csvLink],
		renderCell: ({ value }: { value: any }) => {
			const { showAlert } = useContext(AppContext);
			const [css] = useStyletron();
			const [imageLoaded, setImageLoaded] = useState(false);
			const handleCopyLink = async (e: React.MouseEvent<HTMLAnchorElement>): Promise<void> => {
				e.preventDefault();
				if (!imageLoaded) {
					try {
						await navigator.clipboard.writeText(value);
						showAlert('Copied CSV link');
					} catch {
						showAlert('Failed to copy CSV link', { type: 'error' });
					}
				}
			};
			return (
				<div>
					<a
						href={value}
						target='_blank'
						rel='noreferrer'
						onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
							if (!imageLoaded) {
								handleCopyLink(e);
							} else {
								e.preventDefault();
								window.open(value, '_blank');
							}
						}}>
						<button type='button' style={buttonStyles}>
							<img
								src={value}
								alt={EMPTY_STRING}
								className={css({ height: '90px' })}
								onLoad={() => setImageLoaded(true)}
								onError={(e) => {
									const img: HTMLImageElement = e.target as HTMLImageElement;
									img.style.display = NONE_LABEL;
									const link: HTMLElement | null = img.parentElement;
									if (link) {
										link.innerText = CSV_LINK_LABEL;
										Object.assign(link.style, linkStyles);
									}
								}}
							/>
						</button>
					</a>
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 150,
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING,
		columnName: COL_NAMES.createdBy
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 120,
		maxWidth: 120,
		columnName: COL_NAMES.createdAt
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
